import{_ as r}from"./_Symbol.js";import{i as o}from"./isArguments.js";import{i as s}from"./isArray.js";var a=o,i=s,m=r?r.isConcatSpreadable:void 0;var t=function(r){return i(r)||a(r)||!!(m&&r&&r[m])};export{t as _};
